import { gql } from '@apollo/client';

const CREATE_COURSE_CERTIFICATE = gql`
    mutation($input: CreateCourseCertificateInput!) { 
        result: createCourseCertificate(input: $input) { 
            id
        }
    }
`;

export default CREATE_COURSE_CERTIFICATE;
